import { useMemo } from 'react';
import { useWindowSize } from 'react-use';

/**
 * Returns the current display aspect ratio (width / height).
 * Defaults to 16/9 if dimensions are not available.
 *
 * @returns The aspect ratio as a number
 */
export const useDisplayAspectRatio = (): number => {
  const { width, height } = useWindowSize();

  return useMemo(() => {
    if (!width || !height) {
      return 16 / 9; // Fallback
    }
    return width / height;
  }, [width, height]);
};
